export default function Logo({ size = "md", dark = false }) {
  const sizeMap = {
    sm: { svg: 26, textSize: "14px" },
    md: { svg: 32, textSize: "16px" },
    lg: { svg: 44, textSize: "22px" },
  };
  const { svg: s, textSize } = sizeMap[size] || sizeMap.md;

  const shieldBg   = dark ? "#1A3F5C" : "#0F3D5C";
  const textPrimary = dark ? "#FFFFFF" : "#0E1621";
  const textAccent  = dark ? "#7BB8D4" : "#0F3D5C";

  return (
    <div style={{ display: "flex", alignItems: "center", gap: "9px", height: s }}>
      <svg width={s} height={s} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <rect width="32" height="32" rx="8" fill={shieldBg} />
        {/* Shield outline */}
        <path
          d="M16 5L7 8.5V15c0 5.25 3.9 10.15 9 11.35C21.1 25.15 25 20.25 25 15V8.5L16 5z"
          fill="white"
          fillOpacity="0.12"
          stroke="white"
          strokeOpacity="0.35"
          strokeWidth="1"
        />
        {/* Split — left half grey tint */}
        <path
          d="M16 5L7 8.5V15c0 5.25 3.9 10.15 9 11.35V5z"
          fill="white"
          fillOpacity="0.08"
        />
        {/* Divider */}
        <line x1="16" y1="5.5" x2="16" y2="26" stroke="white" strokeOpacity="0.25" strokeWidth="0.75" />
        {/* ? mark left */}
        <text x="11.5" y="20" fontSize="9" fontWeight="700" fill="white" fillOpacity="0.45"
              textAnchor="middle" fontFamily="DM Sans, sans-serif" style={{ userSelect: "none" }}>
          ?
        </text>
        {/* Check right */}
        <polyline points="19,16.5 21.8,19.5 26,13" stroke="white" strokeWidth="2"
                  strokeLinecap="round" strokeLinejoin="round" fill="none" />
      </svg>

      <span style={{
        fontFamily: "'Syne', sans-serif",
        fontWeight: 700,
        fontSize: textSize,
        letterSpacing: "-0.02em",
        color: textPrimary,
        whiteSpace: "nowrap",
        lineHeight: 1,
      }}>
        Fiable<span style={{ color: textAccent }}> ou Pas</span>
      </span>
    </div>
  );
}
